export default __webpack_public_path__ + "static/media/logo.78777f2c.png";